import appStarterFactory from 'bundles/page/lib/appStarterFactory';
import appEnv from 'bundles/resources/appEnv';

export default appStarterFactory(appEnv);
